import * as React from "react";
import classNames from "classnames";
import { WithStyles, withStyles, createStyles, Theme, StyleRulesCallback } from './styles';
import MuiChip from "@material-ui/core/Chip";
import { PropTypes } from "../index";


export interface ChipProps {
    label?: React.ReactNode;
    color?: PropTypes.Color;
    variant?: 'default' | 'outlined';
}


class Chip extends React.PureComponent<ChipProps & WithStyles<typeof styles>> {
    render() {
        const { color, classes, ...other } = this.props;
        const className = classNames([
            { [classes.root]: true },
            { [classes.colorPrimary]: color === 'primary' },
            { [classes.colorSecondary]: color === 'secondary' },
            { [classes.colorSuccess]: color === 'success' },

            { [classes.colorInfo]: color === 'info' },
            { [classes.colorWarning]: color === 'warning' },
            { [classes.colorDanger]: color === 'danger' },

        ]);


        return <MuiChip {...other} className={className} classes={{ label: classes.label }} />
    }
}




const styles = ((theme: Theme) => createStyles({
    root: {
        //        paddingLeft: 8,
        //        paddingTop: 8,
        //       paddingBottom: 4,
        //       paddingRight: 4,
        fontSize: '0.70rem',
        fontWeight: 'bold',
        padding: 4,
        height: 'auto'
    },
    label: {
        color: "#fff",
        paddingLeft: 4,
        paddingRight: 4,
    },
    colorPrimary: {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
    },
    colorSecondary: {
        color: theme.palette.secondary.contrastText,
        backgroundColor: theme.palette.secondary.main,
    },
    colorSuccess: {
        color: theme.palette.success.contrastText,
        backgroundColor: theme.palette.success.main,
    },
    colorInfo: {
        color: theme.palette.info.contrastText,
        backgroundColor: theme.palette.info.main,
    },
    colorWarning: {
        color: theme.palette.warning.contrastText,
        backgroundColor: theme.palette.warning.main,
    },

    colorDanger: {
        color: theme.palette.danger.contrastText,
        backgroundColor: theme.palette.danger.main,
    }
})) as StyleRulesCallback;

export default withStyles(styles)(Chip);